import { Component, OnInit } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SourceService } from 'src/app/admin/source/source.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { PluginsService } from '../plugins/plugins.service';
import { ActivatedRoute, Router } from '@angular/router';
import { pipe } from '@angular/core/src/render3/pipe';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.scss']
})
export class SourceComponent implements OnInit {
  source$: Observable<any>
  plugins$: Observable<any>
  source: any
  form: FormGroup
  isNew: boolean
  formError: any
  hideExtras: boolean
  hideUrls: boolean

  constructor(
    private ss: SourceService,
    private fb: FormBuilder,
    private ps: PluginsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  ngOnInit() {
    this.plugins$ = this.ps.getPluginsPicker()
    this.source$ = this.ss.getSource()
    this.route.url.subscribe(url => {
      this.isNew = url.toString().endsWith('new')
      if (this.isNew) {
        this.source = {}
        this.createForm()
      }
    })
    this.source$.subscribe(data => {
      this.source = data
      this.createForm()
    })
  }

  createForm = () => {
    this.form = this.fb.group({
      name: [this.source.name, Validators.required],
      ac_group: [this.source.ac_group, Validators.required],
      plugin: [this.source.plugin, Validators.required],
      public_key: [this.source.public_key],
      private_key: [this.source.private_key],
      update_interval: [this.source.update_interval, Validators.min(1)],
      extra1: [this.source.extra1],
      extra2: [this.source.extra2],
      extra3: [this.source.extra3],
      extra4: [this.source.extra4],
      extra5: [this.source.extra5],
      ovr_url_provider: [this.source.ovr_url_provider],
      ovr_url_facility: [this.source.ovr_url_facility],
      ovr_url_insurance: [this.source.ovr_url_insurance],
      ovr_url_department: [this.source.ovr_url_department],
      ovr_url_event: [this.source.ovr_url_event],
      ovr_image_url_provider: [this.source.ovr_image_url_provider],
      ovr_image_url_facility: [this.source.ovr_image_url_facility],
      ovr_image_url_event: [this.source.ovr_image_url_event],
      notes: [this.source.notes],
    })
  }

  saveSource = () => {
    this.formError = undefined


    if (!this.isNew && !window.confirm(`Are you sure you want to save changes to ${this.source.name}?`)) return

    let saveData = {
      id: this.source.id,
      name: this.name.value,
      ac_group: this.acGroup.value,
      plugin: this.plugin.value,
      public_key: this.publicKey.value,
      private_key: this.privateKey.value,
      update_interval: this.updateInterval.value,
      ovr_url_provider: this.ovrUrlProvider.value,
      ovr_url_facility: this.ovrUrlFacility.value,
      ovr_url_insurance: this.ovrUrlInsurance.value,
      ovr_url_department: this.ovrUrlDepartment.value,
      ovr_url_event: this.ovrUrlEvent.value,
      ovr_image_url_provider: this.ovrImageUrlProvider.value,
      ovr_image_url_facility: this.ovrImageUrlFacility.value,
      ovr_image_url_event: this.ovrImageUrlEvent.value,
      notes: this.notes.value,
    }

    if (this.isNew) this.ss.createSource(saveData).pipe(
      catchError(err => {
        this.formError = err
        return throwError(err)
      })
    ).subscribe(data => {
      this.router.navigate(['..', data.id], { relativeTo: this.route })
    })
    else this.ss.saveSource(saveData).pipe(
      catchError(err => {
        this.formError = err
        return throwError(err)
      })
    ).subscribe(data => {
      this.form.reset()
      this.createForm()
    })
  }

  synchronizeSource = () => {
    if (!window.confirm(`Are you sure you want to synchronize the cache for ${this.source.name}?`)) return
    this.ss.synchronizeSource().subscribe()
  }

  setActive = (active: boolean) => {
    if (!window.confirm(`Are you sure you want to ${active ? 'activate' : 'inactivate'} ${this.source.name}?`)) return
    this.ss.setActive(active).subscribe()
  }

  get name() { return this.form.get('name') }
  get acGroup() { return this.form.get('ac_group') }
  get plugin() { return this.form.get('plugin') }
  get publicKey() { return this.form.get('public_key') }
  get privateKey() { return this.form.get('private_key') }
  get updateInterval() { return this.form.get('update_interval') }
  get ovrUrlProvider() { return this.form.get('ovr_url_provider') }
  get ovrUrlFacility() { return this.form.get('ovr_url_facility') }
  get ovrUrlInsurance() { return this.form.get('ovr_url_insurance') }
  get ovrUrlDepartment() { return this.form.get('ovr_url_department') }
  get ovrUrlEvent() { return this.form.get('ovr_url_event') }
  get ovrImageUrlProvider() { return this.form.get('ovr_image_url_provider') }
  get ovrImageUrlFacility() { return this.form.get('ovr_image_url_facility') }
  get ovrImageUrlEvent() { return this.form.get('ovr_image_url_event') }
  get notes() { return this.form.get('notes') }
}
